<template>
    <div class="copyright">
        <img src="@/assets/mobile/AI_Logo-ff4e72d9.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
    .copyright{
        padding: 30px 0;
        text-align: center;
        img{
            height: 42px;
        }   
    }
</style>